import { render, staticRenderFns } from "./AsistenciasDia.vue?vue&type=template&id=b8f0e98c"
import script from "./AsistenciasDia.vue?vue&type=script&lang=js"
export * from "./AsistenciasDia.vue?vue&type=script&lang=js"
import style0 from "./AsistenciasDia.vue?vue&type=style&index=0&id=b8f0e98c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports